
import React, { useCallback, useMemo, useState } from 'react';
import { ReactSVG } from 'react-svg';
import { 
  css, styled, fluidRange, respondTo, 
  breakpoints, transitionDefault, colors, calcRem
} from '~/styles';

import { resourceAssetUrl } from '~/utils';
import iconDownload from '~/assets/images/icon-download-1.svg';
import iconHeart from '~/assets/images/icon-heart-1.svg';
import { Stylable } from '~/types';
import { IResource, useDispatch, useSelector, actions } from '~/redux';
import _ from 'lodash';
import content from '~/utils/contentAPI';
import config from '~/config';

import ReactGA from 'react-ga';

import stripHTML from '~/utils/stripHTML';

export const StyledActions = styled.div`
  flex: 0 1 0;
  display: flex;
  flex-direction: row;

  .mode-list & {
    @media (min-width: 768px) {
      flex: 0 0 90px;
      justify-content: flex-end;
    }
  }

  ${respondTo(breakpoints.md, css`
    align-self: flex-start;
    flex-direction: column;
    align-items: flex-end;

    a {
      &:not(:last-of-type) {
        margin-bottom: 5px;
      }
    }
  `)};

  /* action icon */
  a {
    &:not(:first-of-type) {
      /* ${fluidRange('marginLeft', '10px', '20px', breakpoints.md, breakpoints.xl)} */
      margin-left: ${calcRem(20)};
    }
    img, svg {
      /* ${fluidRange('width', '25px', '40px', breakpoints.sm, breakpoints.md)}
      ${fluidRange('height', '25px', '40px', breakpoints.sm, breakpoints.md)} */

      width: ${calcRem(40)};
      height: ${calcRem(40)};
    }
    div {
      display: inline-block;
    }

    path {
      ${transitionDefault};
      transition-property: fill, stroke, transform, opacity;
    }
    
    &.icon-fav {
      path {
        fill: rgba(255, 255, 255, 1);
      }

      // &:hover {
      //   path {
      //     fill: rgba(255, 0, 0,  0.2);
      //     stroke: rgb(50, 0, 0);
      //   }
      // }
      
      &.active {
        path {
          fill: ${colors.red};
          stroke: ${colors.red};
        }
      }
      &.saving {
        path {
          fill: rgba(255, 0, 0, 0.5);
          stroke: rgb(120, 0, 0);
        }
      }
    }

    &.icon-download {
      &:hover {
        .part-1 {
          transform: translateY(8px);
        }
      }
    }
  }
`

export const StyledTitle = styled.h4`
  /* ${fluidRange('fontSize', '22px', '29.5px', breakpoints.md, breakpoints.lg)} */
  font-size: ${calcRem(29.5)};
  letter-spacing: -0.01em;
  line-height: normal;

  ${respondTo(breakpoints.md, css`
    ${fluidRange('fontSize', '16px', '29.5px', breakpoints.xs, breakpoints.md)}
  `)}
`

export const StyledType = styled.div`
  /* ${fluidRange('fontSize', '16px', '20.5px', breakpoints.md, breakpoints.lg)} */
  font-size: ${calcRem(20.5)};
  color: #6d6e71;
  text-transform: uppercase;
  line-height: 1.17;

  ${respondTo(breakpoints.md, css`
    ${fluidRange('fontSize', '12px', '20.5px', breakpoints.xs, breakpoints.md)}
  `)}
`


interface ResourcesItemActionsProps extends Stylable {
  resource: IResource;
}
export const ResourcesItemActions: React.FC<ResourcesItemActionsProps> = ({ 
  className, resource
}) => {
  const resourcesState = useSelector(state => state.resources);
  const user = useSelector(state => state.user);
  // const isFav = useMemo(() => _.includes(resourcesState.favoriteResources, resource.id), [resourcesState, resource]);
  const isFav = useMemo(() => _.find(user?.favoriteResources, ['id', resource.id]), [user, resource]);
  const [isFavSaving, setIsFavSaving] = useState(false);


  const dispatch = useDispatch();
  const toggleFav = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    
    const toggleRemoteFav = async () => {
      setIsFavSaving(true);

      let updatedUser;
      if (isFav) {
        if (config.debug) { console.log('should remove', resource, 'from', user?.favoriteResources); }
  
        updatedUser = await content.removeFavoriteResource(user?.favoriteResources, resource, user?.contentID);

        ReactGA.event({
          category: 'Favorite Resource',
          action: 'remove favorite',
          label: stripHTML(resource.title)
        });
      } else {
        if (config.debug) { console.log('should add', resource, 'to', user?.favoriteResources); }
  
        updatedUser = await content.addFavoriteResource(user?.favoriteResources, resource, user?.contentID);
        ReactGA.event({
          category: 'Favorite Resource',
          action: 'add favorite',
          label: stripHTML(resource.title)
        });
      }

      setIsFavSaving(false);
      if (config.debug) { console.log('updated user favorites', updatedUser); }
  
      dispatch({
        type: actions.TOGGLE_RESOURCE_FAV,
        payload: updatedUser.favorited_resources
      });
    }
    toggleRemoteFav();
    
  }, [dispatch, resource]);

  const assetURL = useMemo(() => resourceAssetUrl(resource), [resource]);

  const handleDownloadAsset = useCallback((e) => {
    e.stopPropagation();

    ReactGA.event({
      category: 'Download',
      action: 'Download resource',
      label: stripHTML(resource.title)
    });
  }, []);

  return (
    <StyledActions className={className}>
      { !!assetURL && 
          <a href={assetURL} target='_blank' rel='noopener noreferrer' 
          className='icon-download'
          title='Download'
          onClick={handleDownloadAsset}
        >
          <ReactSVG alt='Download' src={iconDownload} />
        </a>
      }
      <a href='#!' className={`
          icon-fav
          ${isFav ? 'active' : ''}
          ${isFavSaving ? 'saving' : ''}
        `}
        onClick={toggleFav}
        title='Favorite'
        >
        <ReactSVG alt='Favorite' src={iconHeart} />
      </a>
    </StyledActions>
  )
}


// WEBPACK FOOTER //
// ./src/components/layout/resources/ResourcesItemCommon.tsx